"use client";

import { useBooking } from "@/contexts/BookingContext";
import { BookingStep } from "@/types/booking";
import LandingPage from "./steps/LandingPage";
import StaffSelection from "./steps/StaffSelection";
import TimeAndDate from "./steps/TimeAndDate";
import PhoneForm from "./steps/PhoneForm";
import Payment from "./steps/Payment";
import Success from "./steps/Success";
import PurchaseSuccessful from "./steps/PurchaseSuccessful";
import VoucherCheckout from "./steps/VoucherCheckout";
import GiftCardCheckout from "./steps/GiftCardCheckout";
import ProductCheckout from "./steps/ProductCheckout";
import GuestsAndServices from "./steps/GuestsAndServices";

export default function BookingSteps() {
  const { step } = useBooking();

  switch (step) {
    case BookingStep.INITIAL:
      return <LandingPage />;
    case BookingStep.GUESTS_AND_SERVICES:
      return <GuestsAndServices />;
    case BookingStep.STAFF_SELECTION:
      return <StaffSelection />;
    case BookingStep.TIME_AND_DATE:
      return <TimeAndDate />;
    case BookingStep.PHONE_FORM:
      return <PhoneForm />;
    case BookingStep.PAYMENT:
      return <Payment />;
    case BookingStep.SUCCESS:
      return <Success />;
    case BookingStep.PURCHASE_SUCCESSFUL:
      return <PurchaseSuccessful />;
    case BookingStep.VOUCHER_CHECKOUT:
      return <VoucherCheckout />;
    case BookingStep.GIFT_CARD_CHECKOUT:
      return <GiftCardCheckout />;
    case BookingStep.PRODUCT_CHECKOUT:
      return <ProductCheckout />;
    default:
      return <LandingPage />;
  }
}
